import KeyDetails from './key_details';

export default KeyDetails;
